import request from '@/utils/request'
import qs from 'qs'

export function getCommonLogList(data) {
    data = qs.stringify(data)
    return request({
        url: '/data/getCommonLogList',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/data.js